// src/components/Header/Header.tsx
import React from 'react';
import styles from './Services.module.css';
import { useTranslation } from 'react-i18next';


interface NavItem {
  title: string;
  description: string;
  image: string;
  status?: string;
}



const InformationCard: React.FC<NavItem> = ({
  title,
  description,
  image,
  status = '' // Optional status prop for 'coming-soon' or 'in-progress' 
}) => {
  const { i18n } = useTranslation();
  return (

    <div className={styles.infoCards}>
      {status && (
        <div className={styles.overlay}>
          <span className={styles.overlayText}>
            {status}
          </span>
        </div>
      )}
      <p className={styles.infoCardTitle}>{title}</p>
      <img
        src={image}
        className={styles.infoCardImage}
        alt={title}
      />
      <p  className={`${styles.infoCardDescription} ${
    i18n.language === 'ar' ? styles.arabic : ''
  }`} >{description}</p>
    </div>
  );

}

export default InformationCard;
